var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlueLines = function SvgBlueLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 110 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b0f0",
    d: "M2.3 55.2 20.7 5a5.5 5.5 0 0 1 6.6-3.8c2.6.7 4.8 3.9 3.8 6.6L12.6 58.1A5.5 5.5 0 0 1 6 61.8c-2.6-.7-4.7-3.8-3.7-6.6M37.5 73.3a344 344 0 0 1 52.1-43.4 5.3 5.3 0 0 1 5.4 9.2 333 333 0 0 0-49.9 41.8c-4.9 4.9-12.5-2.7-7.6-7.6M66.9 106l3.8.7c.9.1-1.3-.1.2 0h1l2.4.2a87 87 0 0 0 10.2.2l4.9-.2 2.7-.3h2.6l1.2-.2 2.1-.4 4-1a5.3 5.3 0 1 1 2.8 10.3c-6.4 2.1-13.6 2.6-20.3 2.8s-13.8 0-20.4-1.6a5.3 5.3 0 1 1 2.8-10.5"
  })));
};
export default SvgBlueLines;